import React, { useState } from "react";
import HouseMap from "../components/HouseMap";
import StoryContinue from "../components/StoryContinue";
const AboutSection: React.FC = () => {
  const [showMore, setShowMore] = useState(false);
  const paragraphs = [
    "House of Bombay exists because some cities never leave you. Bombay is one of them.",
    "It is a city that teaches you how to live with others, at crowded tables, on shared benches, in moments that begin with food and end with stories. It doesn’t ask where you come from before it offers you a seat. It feeds first, listens later, and somehow makes room for one more. House of Bombay is our ode to that instinct.",
    "Not a recreation of the city, but a reflection of its spirit, the paradoxes it holds so easily. Old and new. Quiet and kinetic. Comfort and curiosity. Familiar flavours served with a modern pulse. A place where memory and momentum sit side by side.",
    "We built this house as a space of welcome. For those who grew up with Bombay in their bones, and for those meeting it for the first time. For long conversations, shared plates, lingering chai, and meals that feel like they belong to you. Because hospitality, the way Bombay understands it, has never been about perfection. It has always been about generosity. And here, across the ocean, the city finds its table again.",
    "With warmth, House of Bombay",
  ];
  return (
    <section className="about-section">
      {/* LETTER SECTION */}

      <div className="about-container">
        <div className="about-content">
          <div className="letter-container">
            <div className="line-heading">
              <div className="small-line"></div>
              <p className="explore" style={{ fontWeight: "700" }}>
                DEAR YOU,
              </p>
            </div>

            <div className="letter-card">
              <div className="content">
                {paragraphs.map((p, i) => (
                  <p key={i} className="paddingleftright">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>

          {/* HOSTS TITLE */}

          <div className="hosts-header">
            <h2>Meet Your Hosts</h2>

            <p>
              Every house carries the imprint of those who imagined it. House of
              Bombay is built by people shaped by the city long before they
              decided to serve it.
            </p>
          </div>
        </div>
        {/* HOST GRID */}

        <div className="founders-container">
          {/* Founder 1 */}
          <div className="founder-row">
            <div className="founder-image">
              <div className="ddiamond">
                <img src="/Nishiket.png" alt="Founder" />
              </div>
            </div>

            <div className="founder-text">
              <h3 className="founder-name">Nishiket Parikh</h3>
              <p className="founder-role">Founder</p>

              <p>
                Nishiket grew up in Bombay, in and around restaurants,
                conversations, and the quiet understanding that food is never
                just food. It’s how people gather, how days are marked, how
                relationships are built. Over the years, he has owned, launched,
                and operated multiple restaurant brands across Bombay, learning
                the city not just as a diner, but from behind the scenes from
                finding the right location to shaping menus, managing teams, and
                keeping the rhythm of a restaurant alive, day after day. 
              </p>

              <p>
                House of Bombay is personal for him. It’s an extension of the
                way he understands hospitality, thoughtful, disciplined,
                generous. A place built to last, not rush. A house that feels as
                considered as it is warm. 
              </p>
            </div>
          </div>

          {/* Founder 2 */}
          <div className="founder-row reverse">
            <div className="founder-text-2">
              <h3 className="founder-name">Shivani Shroff</h3>
              <p className="founder-role">Co-Founder</p>

              <p>
                Shivani sees Bombay in details. In colours faded by sun and
                rain. In textures that carry memory. In the way old and new sit
                comfortably side by side. Trained at the London College of
                Fashion, she leads the creative and brand vision of House
                of Bombay, shaping everything from the interiors and visual
                identity to the smallest touchpoints guests interact with. Her
                approach is intuitive but intentional, design that feels
                lived-in, not staged.  
              </p>

              <p>
                For Shivani, House of Bombay is about translating emotion into
                experience. Making sure the space feels welcoming, layered, and
                quietly expressive, much like the city that inspired it. 
              </p>
            </div>

            <div className="founder-image">
              <div className="ddiamond">
                <img src="/Shivani.png" alt="Founder" />
              </div>
            </div>
          </div>

          {/* Founder 3 */}
          <div className="founder-row">
            <div className="founder-image">
              <div className="ddiamond">
                <img src="/Krishna.png" alt="Founder" />
              </div>
            </div>

            <div className="founder-text">
              <h3 className="founder-name">
                Chef Krishna P. Khetle (Chef KK) 
              </h3>
              <p className="founder-role">Executive Culinary Advisor</p>

              <p>
                Known across the industry as Chef KK, Krishna P. Khetle brings
                over two decades of culinary and hospitality experience to House
                of Bombay. From beginning his journey as a young commis chef in
                2001 to founding KK Hospitality and helping launch more than 75
                restaurants across India and internationally, he has built a
                reputation for combining culinary excellence with thoughtful
                brand building.
              </p>
              <p>
                As Executive Culinary Advisor, he brings invaluable perspective
                and mentorship to the house, helping shape a menu that honours
                Bombay’s rich food culture while presenting it through a
                contemporary lens.
              </p>
            </div>
          </div>
          {/* Founder 5 */}
          <div className="founder-row reverse">
            <div className="founder-text-2">
              <h3 className="founder-name">Chef Sunil Gangwal</h3>
              <p className="founder-role">Culinary Director | Executive Chef</p>

              <p>
                With over 24 years of experience in luxury hospitality and fine
                dining, Chef Sunil Gangwal is celebrated for his refined
                approach to Indian cuisine, seamlessly blending authentic
                flavors with contemporary culinary artistry. Having led
                prestigious kitchens and food & beverage operations across
                renowned hospitality brands, including leadership roles with
                Marriott, Renaissance, and Hilton, Chef Sunil brings a legacy of
                excellence, innovation, and guest-centric dining experiences.
              </p>
              <p>
                His culinary philosophy is rooted in honoring tradition while
                elevating it through modern techniques, creating sophisticated
                and memorable experiences for today's discerning guests.
              </p>
            </div>

            <div className="founder-image">
              <div className="ddiamond">
                <img src="/sunil.png" alt="Chef" />
              </div>
            </div>
          </div>
        </div>
        <HouseMap />
        <StoryContinue />
      </div>
    </section>
  );
};

export default AboutSection;
